import { render } from "./AllComp.vue?vue&type=template&id=483abaac&scoped=true"
const script = {}

import "./AllComp.vue?vue&type=style&index=0&id=483abaac&scoped=true&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483abaac"]])

export default __exports__